export function getFile(response) {
  var result = document.createElement('a');
  var contentDisposition = response.headers['content-disposition'] || '';

  var filename = contentDisposition.split("filename*=UTF-8''")[1];
  if (filename.indexOf(';') > 0)
    filename = filename.split(';')[0];
  filename = decodeURIComponent(filename).replace(/"/g, "")

  result.href = window.URL.createObjectURL(response.data);
  result.target = '_self';
  result.download = filename;

  //saveFile(response.data, filename);

  return result;
}

function saveFile(blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0)
  }
}
